<template>
  <div class="footer">
    <div class="footer-top">
      <div class="navigation-bar-wrapper">
        <ul class="navigation-bar three chinese">
          <li class="navigation-item sign-up" @click="navigationo('http://kittyhow.com/login/#/agreement')">用户协议</li>
          <a class="navigation-item privacy" @click="privacyPolicy" type="activxobject(word.application)">隐私政策</a>
          <li class="navigation-item complaint" @click="navigationo('http://kittyhow.com/login/#/tutorial/index')">常见问题</li>
        </ul>
      </div>
    </div>


    <div class="info">
      <span class="line">
        <a href="//beian.miit.gov.cn" title="无用科技_苏ICP备">苏ICP备 20004162号-4 Copyright © 2022 苏州无用科技有限公司</a>
        <span> | 出版物经营许可证：新出发苏园Y字第0476号</span>
        <router-link to="/increment"> | 增值电信业务经营许可证：苏B2-20220615</router-link>
      </span>
      <span class="line">
        <span class="">客服电话：{{zsmServiceMobile}}</span>
        <span class=""> | 地址：苏州工业园区裕兴路168号1号楼219</span>
        <span class=""> | 2022 苏公网安备 32059002003935号 <i class="police"></i> </span>
      </span>






    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        zsmServiceMobile: '' //客服电话
      }
    },
    mounted() {
      this.$store.dispatch('zsm-dict/settingConfig', 'zsm_service_mobile').then((info) => {
        this.zsmServiceMobile = info
      })
    },
    methods: {
      // 打开文档
      privacyPolicy() {

         window.open("https://kittyhow.com/privacy-policy/","_blank");

      /* var doc = new ActiveXObject("Word.Application");
          doc.visible = true;
          doc.Documents.Open("https://file.jinglinshe.com/privacy-policy.docx"); */
      },
      navigationo(url) {
        window.open(url, "_blank");
      }
    }
  }
</script>

<style lang="scss" scoped="scoped">
  .footer {
    font-size: 14px;
    color: #333;
    box-sizing: border-box;
    position: relative;
    padding-top: 50px;
    padding-bottom: 50px;
    z-index: 9999;
    // background-color: #F7F7F7;
    zoom: .9;

    .info {
      .police {
        font-family: PingFang SC, Helvetica, Arial, sans-serif;
        font-size: 12px;
        line-height: 18px;
        font-weight: 400;
        white-space: nowrap;
        -webkit-tap-highlight-color: transparent;
        color: #999;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        margin-left: 5px;
        width: 18px;
        height: 18px;
        background-repeat: no-repeat;
        background-size: contain;
        cursor: pointer;
        background-image: url("https://file.jinglinshe.com/b0b2023e-bf3c-4994-9b67-cb8758739684.png");
      }

      font-family: PingFang SC,
      Helvetica,
      Arial,
      sans-serif;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 40px;
      font-size: 12px;
      line-height: 18px;
      font-weight: 400;
      color: #999;

      .line {
        display: block;
        font-family: PingFang SC, Helvetica, Arial, sans-serif;
        box-sizing: border-box;
        text-align: center;
        width: 100%;
        font-size: 12px;
        height: 30px;
        line-height: 18px;
        font-weight: 400;
        color: #999;

        a {
          font-family: PingFang SC, Helvetica, Arial, sans-serif;
          font-size: 12px;
          line-height: 18px;
          font-weight: 400;
          white-space: nowrap;
          box-sizing: border-box;
          -webkit-tap-highlight-color: transparent;
          text-decoration: none;
          color: #999;
        }
      }
    }

    .footer-top {
      font-family: PingFang SC, Helvetica, Arial, sans-serif;
      box-sizing: border-box;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      color: #333;

      .navigation-bar-wrapper {
        font-family: PingFang SC, Helvetica, Arial, sans-serif;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        color: #333;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 0 0 20px;

        .navigation-bar {
          font-family: PingFang SC, Helvetica, Arial, sans-serif;
          font-size: 14px;
          font-weight: 500;
          text-align: center;
          color: #333;
          box-sizing: border-box;
          width: 1080px;
          margin: 0;
          padding: 0 80px 0 60px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          list-style-type: none;
          position: relative;
        }

        .navigation-item {
          font-family: PingFang SC, Helvetica, Arial, sans-serif;
          font-size: 14px;
          font-weight: 500;
          color: #333;
          list-style-type: none;
          box-sizing: border-box;
          cursor: pointer;
        }
      }
    }
  }
</style>
